import React from 'react';
import { ProductForm } from './components/ProductForm';
import './ByoForm.scss';

const ByoForm = () => <ProductForm />;

export default ByoForm;
